function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import PropTypes from 'prop-types';
import React from 'react';
import CheckboxInput from "./CheckboxInput";
import FileInput from "./FileInput";
import FormLabelGroup from "./FormLabelGroup";
import Input from "./Input";
import RadioInput from "./RadioInput";
import StaticInput from "./StaticInput";
var typeTranslations = {
  checkbox: CheckboxInput,
  radio: RadioInput,
  static: StaticInput,
  file: FileInput
};

function determineElement(type) {
  return typeof type === 'string' ? typeTranslations[type] || Input : type;
}

function inputType(type) {
  if (typeof type !== 'string') return null;
  if (type === 'static') return null;
  return type;
}

function parseFeedback(feedback) {
  return _typeof(feedback) === 'object' ? [null, {
    error: feedback
  }] : [feedback, {}];
}

function sanitizeProps(component, props) {
  if (!component.propTypes) return props;
  var saneProps = {};
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    if (component.propTypes[k]) saneProps[k] = v;
  });
  return saneProps;
}

var FormRow = function FormRow(props) {
  var children = props.children,
      feedback = props.feedback,
      hint = props.hint,
      id = props.id,
      inline = props.inline,
      label = props.label,
      labelSize = props.labelSize,
      required = props.required,
      rowClassName = props.rowClassName,
      size = props.size,
      stacked = props.stacked,
      type = props.type,
      validFeedback = props.validFeedback,
      width = props.width,
      attributes = _objectWithoutProperties(props, ["children", "feedback", "hint", "id", "inline", "label", "labelSize", "required", "rowClassName", "size", "stacked", "type", "validFeedback", "width"]);

  var InputElement = determineElement(type);
  var inputElementType = inputType(type);

  var _parseFeedback = parseFeedback(feedback),
      _parseFeedback2 = _slicedToArray(_parseFeedback, 2),
      baseFeedback = _parseFeedback2[0],
      childFeedback = _parseFeedback2[1];

  var shouldPassChildren = inputElementType === 'checkbox' || inputElementType === 'radio' || inputElementType === 'select';
  var validityThings = sanitizeProps(InputElement, {
    valid: !!validFeedback,
    invalid: !!feedback
  });
  return (
    /*#__PURE__*/
    React.createElement(FormLabelGroup, {
      feedback: baseFeedback,
      hint: hint,
      inline: inline,
      inputId: id,
      label: label,
      labelSize: labelSize,
      required: required,
      rowClassName: rowClassName,
      size: size,
      stacked: stacked,
      validFeedback: validFeedback,
      width: width
    },
    /*#__PURE__*/
    React.createElement(InputElement, _extends({
      id: id,
      size: size,
      type: inputElementType
    }, validityThings, attributes, childFeedback), shouldPassChildren ? React.Children.map(children, function (child) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, {
          type: inputElementType
        })
      );
    }) : undefined))
  );
};

FormRow.displayName = "FormRow";
FormRow.propTypes = {
  children: PropTypes.node,
  feedback: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  hint: PropTypes.node,
  id: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.node,
  labelSize: PropTypes.string,
  required: PropTypes.bool,
  rowClassName: PropTypes.string,
  size: PropTypes.string,
  stacked: PropTypes.bool,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
  validFeedback: PropTypes.node,
  width: PropTypes.object
};
FormRow.defaultProps = {
  feedback: '',
  hint: '',
  inline: false,
  label: '',
  required: false,
  rowClassName: '',
  stacked: false,
  type: 'text'
};
export default FormRow;